<template>
  <div class="competition-preview-panel">
    <img
      v-if="currentImage"
      :src="currentImage"
      :alt="imageAlt"
      class="preview-image"
    />
    <div v-else class="preview-placeholder">
      <i class="fa-regular fa-image"></i>
      <span>Preview not available</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompetitionPreviewPanel",
  props: {
    activeTab: {
      type: String,
      default: 'BasicsTab',
    },
  },
  computed: {

    currentImage() {
      const imageMap = {
        'BasicsTab': this.getImagePath('Basics.png'),
        'PrizesTab': this.getImagePath('Settings.png'), // Usando Settings.png para Prizes
        'RulesTab': this.getImagePath('Rules.png'),
        // Branding y Ranking tienen sus propios previews custom
        'BrandingTab': null,
        'RankingTab': null,
      };

      return imageMap[this.activeTab] || null;
    },

    imageAlt() {
      const altMap = {
        'BasicsTab': 'Competition Basics Preview',
        'PrizesTab': 'Competition Prizes Preview',
        'RulesTab': 'Competition Rules Preview',
      };

      return altMap[this.activeTab] || 'Competition Preview';
    },
  },
  methods: {
    getImagePath(imageName) {
      try {
        // Intenta cargar la imagen desde assets/icons/competition
        return require(`@/assets/icons/competition/${imageName}`);
      } catch (e) {
        // Si no existe, retorna null
        console.warn(`Image not found: ${imageName}`);
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-preview-panel {
  position: relative;
  width: 100%;
  border: 1px solid #9a9a9a;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 12px;
}

.preview-placeholder {
  width: 100%;
  min-height: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--v-cardBackground-base);
  color: #9a9a9a;
  font-size: 14px;

  i {
    font-size: 48px;
    opacity: 0.5;
  }

  span {
    font-family: "Avenir", sans-serif;
    font-weight: 500;
  }
}

.theme--dark .competition-preview-panel {
  border-color: #424242;
}

.theme--dark .preview-placeholder {
  background: var(--v-cardBackground-base);
  color: rgba(255, 255, 255, 0.5);
}
</style>
